export const getEditDietModalSteps = (t) => [
    {
        target: '[data-tour="edm-modal"]',
        placement: 'center',
        title: t('tour.editDietModal.step-welcome-title'),
        content: t('tour.editDietModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="edm-dates"]',
        title: t('tour.editDietModal.step-dates-title'),
        content: t('tour.editDietModal.step-dates-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="edm-table"]',
        title: t('tour.editDietModal.step-table-title'),
        content: t('tour.editDietModal.step-table-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="edm-footer"]',
        title: t('tour.editDietModal.step-footer-title'),
        content: t('tour.editDietModal.step-footer-content'),
        disableBeacon: true,
    },
];
